import { Button, QCard, Saved, WizardNav } from '@concord/ui';
import { usePatchIntake } from '../api';
import type { StepProps } from '../IntakeWizard';
import s from './steps.module.css';

/** The expert pool, where the plan permits a choice (PRD §11 sequence, step 2). */
export function PoolStep({ v, back, next, mode }: StepProps) {
  const patch = usePatchIntake(v.id);
  const single = v.choosablePools.length <= 1;
  const your = mode === 'staff' ? 'their' : 'your';
  return (
    <>
      <QCard
        label="Expert panel"
        title={
          single
            ? `The panel ${your === 'your' ? 'your' : 'this'} plan uses`
            : 'Which panel of physicians should review the case?'
        }
        lead={
          single
            ? `${v.entitlement.planName} sends cases to one group of specialists. The care navigator chooses the individual physicians from it.`
            : `${v.entitlement.planName} offers more than one group of specialists. The care navigator chooses the individual physicians from the group picked here.`
        }
      >
        <div className={s.options} role="radiogroup" aria-label="Expert panel">
          {v.choosablePools.map((p) => (
            <label key={p.id} className={s.opt} data-on={v.pool?.id === p.id || undefined}>
              <input
                type="radio"
                className="sr-only"
                checked={v.pool?.id === p.id}
                disabled={single}
                onChange={() => patch.mutate({ poolId: p.id })}
              />
              <span className={s.r} />
              <span>{p.publicName}</span>
            </label>
          ))}
        </div>
      </QCard>
      <WizardNav
        back={
          <Button variant="sec" onClick={back}>
            Back to case type
          </Button>
        }
        status={v.pool ? <Saved>Saved</Saved> : null}
        next={
          <Button size="lg" onClick={next} disabled={!v.pool}>
            Continue to about {mode === 'staff' ? 'the patient' : 'you'}
          </Button>
        }
      />
    </>
  );
}
